import Banner from "./Banner";
import Regulamin from "./files/AKREDYTACJA_REGULAMIN_REKRUTACJI.pdf";

let Recruitment = () => {
    return(
        <div id = "textContainer">
            
            <h1>Rekrutacja</h1>
            <hr />
            <Banner />
            <hr /> <br />
            <h2><strong>Informacje o procesie rekrutacji</strong></h2>
            <p>Uczniowie z klas III, IV i V technikum ubiegający się o staż zagraniczny w ramach Projektu będą podlegali ocenie według następujących kryteriów:</p>
            <ul>
                <hr className="customRecruitment"/>
                
                <h3><strong>Dla uczniów klas III</strong></h3>
                <li>roczne oceny z przedmiotów zawodowych z klasy II dla uczniów klas o profilu technik informatyk:
                    <ul>
                        <li>Urządzenia techniki komputerowej</li>
                        <li>Administracja systemami operacyjnymi</li>
                        <li>Montaż i konfiguracja lokalnych sieci komputerowych</li>
                    </ul>
                </li>
                <li>roczne oceny z przedmiotów zawodowych z klasy II dla uczniów klas o profilu technik teleinformatyk:
                    <ul>
                        <li>Administracja sieciowymi systemami komputerowymi</li>
                        <li>Konfigurowanie urządzeń sieciowych</li>
                        <li>Sieci lokalne</li>   
                    </ul>
                </li>
                <li>roczne oceny z przedmiotów zawodowych z klasy II dla uczniów klas o profilu technik programista:
                    <ul>
                        <li>Programowanie aplikacji internetowych</li>
                        <li>Tworzenie i zarządzanie bazami danych</li>
                        <li>Programowanie strukturalne i obiektowe w języku Java</li>   
                    </ul>
                </li>
                <li>roczne oceny z przedmiotów zawodowych z klasy II dla uczniów klas o profilu technik urządzeń i systemów energetyki odnawialnej:
                    <ul>
                        <li>Podstawy energetyki</li>
                        <li>Materiały, narzędzia i technologie do montażu systemów energetyki odnawialnej</li>
                        <li>Pracownia montażu urządzeń i systemów energetyki odnawialnej</li>   
                    </ul>
                </li>
                <li>roczna ocena z języka angielskiego z klasy II</li>
                <li>roczna ocena z zachowania z klasy II</li>
                <li>test z języka angielskiego</li>
                <li>test kompetencji z zakresu ICT (dla uczniów klasy o profilu technik informatyk, teleinformatyk, programista)</li>
                <li>test kompetencji z zakresu OZE (dla uczniów klasy o profilu technik urządzeń i systemów energetyki odnawialnej)</li>
                <li>rozmowa kwalifikacyjna w języku angielskim</li>
                <li>frekwencja na zajęciach lekcyjnych</li>
                <li>opinia wychowawcy</li>

                <hr className="customRecruitment"/>
                
                <h3><strong>Dla uczniów klas IV</strong></h3>
                <li>roczne oceny z przedmiotów zawodowych z klasy III dla uczniów klas o profilu technik informatyk:
                    <ul>
                        <li>Witryny i aplikacje internetowe</li>
                        <li>Administracja systemami operacyjnymi</li>
                        <li>Montaż i konfiguracja lokalnych sieci komputerowych</li>
                    </ul>
                </li>
                <li>roczne oceny z przedmiotów zawodowych z klasy III dla uczniów klas o profilu technik teleinformatyk:
                    <ul>
                        <li>Administracja sieciowymi systemami komputerowymi</li>
                        <li>Konfigurowanie urządzeń sieciowych</li>
                        <li>Sieci komputerowe</li>   
                    </ul>
                </li>
                <li>roczne oceny z przedmiotów zawodowych z klasy III dla uczniów klas o profilu technik programista:
                    <ul>
                        <li>Programowanie aplikacji internetowych</li>
                        <li>Programowanie obiektowe i strukturalne</li>
                        <li>Projektowanie aplikacji desktopowych</li>   
                    </ul>
                </li>
                <li>roczne oceny z przedmiotów zawodowych z klasy III dla uczniów klas o profilu technik urządzeń i systemów energetyki odnawialnej:
                    <ul>
                        <li>Technologia montażu systemów energetyki odnawialnej</li>
                        <li>Systemy energetyki odnawialnej</li>
                        <li>Montaż systemów energetyki odnawialnej</li>   
                    </ul>
                </li>
                <li>roczna ocena z języka angielskiego z klasy III</li>
                <li>roczna ocena z zachowania z klasy III</li>
                <li>test z języka angielskiego</li>
                <li>test kompetencji z zakresu ICT (dla uczniów klasy o profilu technik informatyk, teleinformatyk, programista)</li>
                <li>test kompetencji z zakresu OZE (dla uczniów klasy o profilu technik urządzeń i systemów energetyki odnawialnej)</li>
                <li>rozmowa kwalifikacyjna w języku angielskim</li>
                <li>frekwencja na zajęciach lekcyjnych</li>
                <li>opinia wychowawcy</li>
                
                <hr className="customRecruitment"/>
                
                <h3><strong>Dla uczniów klas V</strong></h3>
                <li>roczne oceny z przedmiotów zawodowych z klasy IV dla uczniów klas o profilu technik informatyk:
                    <ul>
                        <li>Witryny i aplikacje internetowe</li>
                        <li>Tworzenie stron i aplikacji internetowych</li>
                        <li>Projektowanie baz danych</li>
                    </ul>
                </li>
                <li>roczne oceny z przedmiotów zawodowych z klasy IV dla uczniów klas o profilu technik teleinformatyk:
                    <ul>
                        <li>Administracja sieciowymi systemami komputerowymi</li>
                        <li>Konfigurowanie urządzeń sieciowych</li>
                        <li>Sieci komputerowe</li>   
                    </ul>
                </li>
                <li>roczne oceny z przedmiotów zawodowych z klasy IV dla uczniów klas o profilu technik programista:
                    <ul>
                        <li>Programowanie obiektowe i strukturalne</li>
                        <li>Projektowanie aplikacji webowych</li>
                        <li>Programowanie zaawansowanych aplikacji webowych</li>   
                    </ul>
                </li>
                <li>roczne oceny z przedmiotów zawodowych z klasy IV dla uczniów klas o profilu technik urządzeń i systemów energetyki odnawialnej:
                    <ul>
                        <li>Obsługa systemów energetyki odnawialnej</li>
                        <li>Systemy energetyki odnawialnej</li>
                        <li>Kosztorysowanie w budownictwie</li>   
                    </ul>
                </li>
                
                <li>roczna ocena z języka angielskiego z klasy IV</li>
                <li>roczna ocena z zachowania z klasy IV</li>
                <li>test z języka angielskiego</li>
                <li>test kompetencji z zakresu ICT (dla uczniów klasy o profilu technik informatyk, teleinformatyk, programista)</li>
                <li>test kompetencji z zakresu OZE (dla uczniów klasy o profilu technik urządzeń i systemów energetyki odnawialnej)</li>
                <li>rozmowa kwalifikacyjna w języku angielskim</li>
                <li>frekwencja na zajęciach lekcyjnych</li>
                <li>opinia wychowawcy</li>
            </ul>

            <hr className="customRecruitment"/>

            <p>Oceny z przedmiotów zawodowych, oceny z języka angielskiego i oceny z testów przeliczane są na punkty:</p>
            <ul>
                <li>ocena celująca: 6 punktów,</li>
                <li>ocena bardzo dobra: 5 punktów,</li>
                <li>ocena dobra: 4 punkty,</li>
                <li>ocena dostateczna: 3 punkty,</li>
                <li>ocena dopuszczająca: 2 punkty.</li>
            </ul>

            <p>Ocena z rozmowy kwalifikacyjnej w języku angielskim przeliczana jest na punkty:</p>
                <ul>
                    <li>ocena celująca: 12 punktów</li>
                    <li>ocena bardzo dobra: 10 punktów</li>
                    <li>ocena dobra: 8 punktów</li>
                    <li>ocena dostateczna: 3 punkty</li>
                    <li>ocena dopuszczająca: 1 punkt</li>
                </ul>

            <p>Frekwencja ucznia na obowiązkowych zajęciach lekcyjnych punktowana jest następująco:</p>
                <ul>
                    <li>90% - 100%: 10 punktów</li>
                    <li>75% - 89%: 8 punktów</li>
                    <li>60% - 74%: 6 punktów</li>
                    <li>50% - 59%: 2 punkty</li>
                    <li>poniżej 50%: 0 punktów</li>
                </ul>

            <p>Ocena z zachowania ucznia punktowana jest następująco:</p>
            <ul>
                <li>wzorowe: 6 punktów</li>
                <li>bardzo dobre: 5 punktów</li>
                <li>dobre: 4 punkty</li>
                <li>poprawne: 2 punkty</li>
                <li>nieodpowiednie: 0 punktów</li>
                <li>naganne: 0 punktów</li>
            </ul>
            
            <p><strong>Uczeń ubiegający się o staż zagraniczny zobligowany jest do wypełnienia, podpisania i wydrukowania Karty kwalifikacyjnej przystąpienia do Projektu zamieszczonej na stronie internetowej Szkoły oraz dostarczenia jej do sekretariatu Szkoły. Ponadto uczeń musi także wypełnić Formularz online dostępny na szkolnej stronie internetowej. Niedopełnienie ww. warunków formalnych rekrutacji spowoduje, że uczeń nie będzie ujęty w dalszym procesie rekrutacji.</strong></p>
            
            <p>Językiem komunikacji w trakcie stażu zagranicznego jest język angielski. W związku z powyższym uczeń ubiegający się o udział w stażu musi posługiwać się językiem angielskim w stopniu komunikatywnym. Kolejność uczniów na liście podstawowej i rezerwowej jest uzależniona nie tylko od ogólnego wyniku uzyskanego przez ucznia w trakcie rekrutacji, ale również od wyniku rozmowy kwalifikacyjnej w języku angielskim.</p>
            
            <p><strong>W wyniku przeprowadzonej rekrutacji sporządzona będzie lista podstawowa: 22 osoby (10 uczniów z kierunku technik informatyk, teleinformatyk, programista, 12 uczniów z kierunku technik urządzeń i systemów energetyki odnawialnej) oraz lista rezerwowa (6 osób).</strong></p>

            <p><strong>Pełna wersja Regulaminu rekrutacji i uczestnictwa w Projekcie znajduje się <a href={Regulamin} target="_blank">TUTAJ</a>.</strong></p>

            <hr className="customRecruitment"/>
            
            <p className = "text-center"><em>Uczniowi przysługuje prawo odwołania do dyrektora Zespołu Szkół Informatycznych w Kielcach w terminie 7 dni od momentu ogłoszenia decyzji Komisji Rekrutacyjnej w przypadku naruszenia Regulaminu rekrutacji i uczestnictwa w Projekcie. Odwołanie musi zawierać przyczynę jego składania wraz z uzasadnieniem. Decyzja Dyrektora jest ogłaszana najpóźniej następnego dnia po rozpatrzeniu sprawy i jest ostateczna.</em></p>  
        </div>
        
    )
}

export default Recruitment;